import { render } from "./EventInfo.vue?vue&type=template&id=c211a0fc&scoped=true"
import script from "./EventInfo.vue?vue&type=script&lang=js"
export * from "./EventInfo.vue?vue&type=script&lang=js"

import "./EventInfo.vue?vue&type=style&index=0&id=c211a0fc&lang=scss&scoped=true"

import exportComponent from "/Users/johnahnz0rs/00 - JAHN PROJECTS/movie-night/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c211a0fc"]])

export default __exports__